import { useState, useCallback } from 'react';

// Services

import OptionsService from '../services/options.service';

export default function GetOfficesByMunicipality() {
    const [getOfficesIsLoading, setGetOfficesIsLoading] = useState(false);
    const [getOfficesError, setGetOfficesError] = useState(null);
    const [offices, setOffices] = useState([]);

    // Get the Parishes by Municipality

    const handleGetOfficesByMunicipality = useCallback(async (municipality) => {
        setGetOfficesIsLoading(true);
        setGetOfficesError(null);

        try {

            const officesRequest = await OptionsService.getOfficesByMunicipality(municipality);

            setGetOfficesIsLoading(false);
            setOffices(officesRequest?.data?.data);

        } catch(error) {

            setGetOfficesIsLoading(false);
            setGetOfficesError(error.response?.data?.message || error.message);

        }
    }, []);

    return {
        getOfficesIsLoading,
        getOfficesError,
        offices,
        handleGetOfficesByMunicipality,
    }
}
